import { Typography, Box, Divider, Button, FormHelperText } from '@material-ui/core';
import {
  Select,
  SelectedItems,
} from '@backstage/core-components';
import { useTemplateSecrets, } from '@backstage/plugin-scaffolder-react';
import { scmAuthApiRef } from '@backstage/integration-react';
import { useApi } from '@backstage/core-plugin-api';
import React, { useState } from 'react';
import { AdoProjectPickerProps } from './schema';

export const AdoProjectPickerComponent = (props: AdoProjectPickerProps) => {

  const {
    onChange,
    required,
    uiSchema,
    rawErrors,
    formData,
    idSchema,
    errors,
  } = props;


  const [adoProjects, setAdoProjects] = useState<{ id: string, name: string, url: string }[] | undefined>(undefined);
  const { secrets, setSecrets } = useTemplateSecrets();


  const scmAuthApi = useApi(scmAuthApiRef);

  const adoOrg = "pandora-jewelry";

  const click = async () => {
    // user has requested that we use the users credentials
    // so lets grab them using the scmAuthApi and pass through
    // any additional scopes from the ui:options
    const { token } = await scmAuthApi.getCredentials({
      url: `https://dev.azure.com`,
      additionalScope: {
        repoWrite: true,
        //customScopes: requestUserCredentials.additionalScopes,
      },
    });

    // set the secret using the key provided in the ui:options for use
    // in the templating the manifest with ${{ secrets[secretsKey] }}
    const newSecrets :Record<string, string> = {};
    newSecrets[uiSchema['ui:options']?.secretsKey ?? "USER_TOKEN"] = token;
    setSecrets(newSecrets);

    fetch(`https://dev.azure.com/${adoOrg}/_apis/projects?stateFilter=wellFormed&$top=1000&getDefaultTeamImageUrl=false&api-version=7.1`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then(data => {
      data.json().then(projects => {
        const sortedProjects = projects.value.sort((a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name));
        setAdoProjects(sortedProjects);
      })
    })
      .catch(error => {
        console.error('Error fetching ADO projects:', error);
      });

  };

  const onProjectChange = (projectId: SelectedItems) => {
    onChange(projectId.toString());
  };

  return (<>
    {adoProjects === undefined ? <>
      <Box my={1}>
        <Typography variant="h5">Click to login to ADO</Typography>
        <Divider />
      </Box>
      <Button variant="contained" color="primary" onClick={click}>
        Login to ADO
      </Button>
    </> : <>
      <Box my={1}>
        <Typography variant="h5">Successfully logged in to ADO</Typography>
        <Divider />
      </Box>
      <Box my={1}>
        <Select
          native
          label="Select ADO Project"
          onChange={onProjectChange}
          disabled={adoProjects === undefined || adoProjects.length === 0}
          items={adoProjects ? adoProjects.map(p => ({ label: p.name, value: p.id })) : []}
        />
        <FormHelperText>Select the ADO project you wish to use for this scaffolding operation</FormHelperText>
      </Box>
    </>}
  </>
  );
};